import {
  IBankPaymentCode,
  ICollectorAccountCodes,
} from '../common/interfaces/bankPaymentCode.interface'
import { apiUrl } from '../config/api'

const BASE_PATH = '/bank-payment-code'

export const BankPaymentCodeService = () => {
  const list = (): Promise<IBankPaymentCode[]> =>
    apiUrl.get(`${BASE_PATH}/list`).then((res) => res.data)

  const toggle = (bankId: number, enabled: boolean): Promise<void> =>
    apiUrl.patch(`${BASE_PATH}/bank/${bankId}/toggle`, { enabled }).then((res) => res.data)

  const updateBankHabitatCode = (bankId: number, habitat_bank_code: string): Promise<void> =>
    apiUrl
      .patch(`${BASE_PATH}/bank/${bankId}/habitat-code`, { habitat_bank_code })
      .then((res) => res.data)

  const updateCollectorAccountCodes = (id: number, codes: ICollectorAccountCodes): Promise<void> =>
    apiUrl.patch(`${BASE_PATH}/collector-account/${id}/codes`, codes).then((res) => res.data)

  return { list, toggle, updateBankHabitatCode, updateCollectorAccountCodes }
}
